import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Navbar,
  HeroSection,
  AboutSection,
  EducationLevels,
  MethodologySection,
  TestimonialsSection,
  NewsSection,
  CallToAction,
  ContactForm,
} from "../../../components/Web";
import { scrollToSection } from "../../../utils/landing/useSmoothNavigate";
import "./Home.scss";

export function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // Esperar a que el DOM esté listo
      setTimeout(() => {
        scrollToSection(location.hash);
      }, 100);
    }
  }, [location.hash]);

  return (
    <main className="client-layout__content min-h-screen bg-secondary">
      <HeroSection />
      <AboutSection />
      <EducationLevels />
      <MethodologySection />
      <TestimonialsSection />
      <NewsSection />
      <CallToAction />
      <ContactForm />
    </main>
  );
}
